import { useState } from 'react';
import { typesConfig } from './constants';

export const BuyDialogType = ({ name, checked, onChange }) => {
  const [isHover, setIsHover] = useState(false);

  const handleChange = (e) => {
    onChange(e.currentTarget.value);
  };

  const { imageHover, image, label, smallLabel } = typesConfig[name];
  const imageSrc = isHover || checked ? imageHover : image;

  return (
    <label
      onMouseOver={() => setIsHover(true)}
      onMouseOut={() => setIsHover(false)}
      className="flex flex-col items-center capitalize cursor-pointer max-w-[18%] md:mx-1.5"
    >
      <input
        className="hidden"
        type="radio"
        checked={checked}
        value={name}
        onClick={handleChange}
        readOnly
      />
      <div className="flex items-end max-h-44 mb-2 md:pb-2 px-0.5 h-full">
        <img src={imageSrc} alt={name} className="max-h-full" />
      </div>
      <span className="md:hidden text-xs text-center">{smallLabel}</span>
      <span className="hidden md:block text-xl text-center">{label}</span>
    </label>
  );
};
